var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUsers = function SvgUsers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M10 18.335a8.333 8.333 0 1 0 0-16.667 8.333 8.333 0 0 0 0 16.667Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M6.25 14.165c1.943-2.035 5.536-2.13 7.5 0m-1.67-6.25c0 1.151-.935 2.084-2.087 2.084a2.085 2.085 0 0 1-2.086-2.084c0-1.15.934-2.083 2.086-2.083s2.086.933 2.086 2.083Z"
  })));
};
export default SvgUsers;